/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.BasicEmailMarketing {
    angular.module("meevo.plugins.basicEmailMarketing", []);
}